'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg1 from '../../assets/images/services/hydraulic-scrap-baler.png'
import ServiceDetailsImg2 from '../../assets/images/services/service-details-images-1-2.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import table, { Table } from 'react-bootstrap'
import SEOHelmet from '../../components/SEO/SEOHelmet';
import VideoOne from '../home-3/VideoOne';
// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/css/modal-video.min.css';
const mainSlider = {
    width: '90%',
}
const HydraulicScrapBaler = () => {
    const images = [
        {
            original: ServiceDetailsImg1,
            thumbnail: ServiceDetailsImg1,
            originalAlt: "Slide 1",
            thumbnailAlt: "Thumbnail 1",
        },
        // { 410X361px
        //     original: ServiceDetailsImg2,
        //     thumbnail: ServiceDetailsImg2,
        //     originalAlt: "Slide 2",
        //     thumbnailAlt: "Thumbnail 2",
        // }

    ]
    // State to hold dynamic content
    const [projectInfo] = useState({
        category: "Roof Service",
        customer: "David Bravis",
        startDate: "21 April 2024",
        endDate: "28 September 2024",
        rating: 5,
    });
    const [socialLinks] = useState([
        { href: "https://www.facebook.com/profile.php?id=61573443062800", iconClass: "icon-facebook-f" },
        { href: "https://x.com/design79356", iconClass: "icon-Vector" },
        { href: "https://www.instagram.com/ramanasteels/", iconClass: "icon-instagram" },
        { href: "https://in.pinterest.com/Ramanasteels/", iconClass: "icon-pinterest" },
    ]);
    const [serviceDetails] = useState({


        image1: ServiceDetailsImg,

        title: "Hydraulic Scrap Baler",
        text2: "Hydraulic Scrap Baler is ideal for cutting the metal shaped in different cross sections like round, square, rectangle, and various waste structural metal at cold state. It brings convenience to the baling, storage and transportation of scrap metal materials, and also offers qualified furnace charges for smelting plants. With a large application range, this machine is commonly used as the processing equipment in the metal recycling unit, casting room of factory and machinery construction industry.",
        points: [
            "Hydraulic drive, operated by manual valve operation of PLC control",
            "Bale discharging supports turn out, push out, forward out as well as manual discharging",
            "Offers multiple options for different force, press box size, bale shape and size",
            "Can be powered by electrical motor, diesel engine or generator for power",

        ],

    });

    return (
        <React.Fragment>
            <SEOHelmet 
                title="Advanced Hydraulic Scrap Baler for Metal Recycling"
                description="Efficient hydraulic scrap baler for cutting metal in various cross-sections. Perfect for metal recycling, casting rooms, and machinery construction industries."
                keywords="hydraulic baler, scrap baler, metal baler, baling machine, metal recycling equipment"
                canonicalUrl="https://ramanasteels.com/hydraulic-scrap-baler"
            />
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">

                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="justify-content-center mt-4">
                                        <div className="card p-3 rounded" style={mainSlider}>
                                            <ImageGallery
                                                items={images}
                                                showPlayButton={false}
                                                showFullscreenButton={true}
                                                showThumbnails={true}
                                                autoPlay={true}
                                                slideInterval={4000}
                                                showNav={true}
                                                additionalClass="img-slider"
                                            />
                                        </div>
                                    </div>
                                    <h1 className="service-details__title-one">{serviceDetails.title}</h1>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    <VideoOne videoId={"28Q68WEL9qo"} />
                                    <ul className="list-unstyled service-details__points">
                                        <h3>Features</h3>
                                        {serviceDetails.points.map((point, index) => (
                                            <li key={index}>
                                                <div className="icon">
                                                    <i className="far fa-check" />
                                                </div>
                                                <div className="text">
                                                    <p>{point}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div>
                                    <Table responsive>
                                        <thead style={{ color: '#FFFFFF', background: '#2F8CD6' }}><tr> <th>Model   </th>
                                            <th>Main Cyl. Force </th>
                                            <th>Press Box Size</th>
                                            <th>Bale Size </th>
                                            <th>Motor</th>
                                        </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td>200</td>
                                                <td>250</td>
                                                <td>2500x2000x1200</td>
                                                <td>500x500/600/600</td>
                                                <td>22*2</td>
                                            </tr>
                                            <tr>
                                                <td>250T</td>
                                                <td>250</td>
                                                <td>2500x2000x1200</td>
                                                <td>500x500/600/600</td>
                                                <td>37*2</td>

                                            </tr>
                                            <tr>
                                                <td>315T</td>
                                                <td>315</td>
                                                <td>3000x2500x1200/3500x3000x1200</td>
                                                <td>600x600/700x700</td>
                                                <td>45*2</td>

                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                                {/* <div className="service-details__images-box">
                                    <div className="row">
                                        {serviceDetails.images.map((image, index) => (
                                            <div key={index} className="col-xl-6 col-lg-6">
                                                <div className="service-details__images-single">
                                                    <img src={image} alt="" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="service-details__content-three">
                                    <h4 className="service-details__title-four">{serviceDetails.content3Title}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text3}</p>
                                    <p className="service-details__text-4">{serviceDetails.text4}</p>
                                </div> */}
                                {/* <div className="service-details__feature-box">
                                    <div className="row">
                                        {serviceDetails.features.map((feature, index) => (
                                            <div key={index} className="col-xl-6">
                                                <div className="service-details__feature-single">
                                                    <div className="service-details__feature-icon-box">
                                                        <div className="service-details__feature-icon">
                                                            <span className={feature.icon} />
                                                        </div>
                                                        <h4 className="service-details__feature-title">
                                                            <Link to={feature.link}>{feature.title}</Link>
                                                        </h4>
                                                    </div>
                                                    <p className="service-details__feature-text">{feature.text}</p>
                                                    <Link to={feature.link} className="service-details__read-more">
                                                        Read more <span className="icon-dubble-arrow-right" />
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="project-details__sidebar">
                                <div className="project-details__project-info">
                                    <h3 className="project-details__project-info-title">
                                        Product Information
                                    </h3>
                                    <ul className="list-unstyled project-details__project-info-list">
                                        <li>
                                            <h5>Origin:</h5>
                                            <h5>China{/* {projectInfo.category} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Make:</h5>
                                            <h5>Gaode{/* {projectInfo.customer} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Used In:</h5>
                                            <h5> Heavy duty scrap<br /> processing{/* {projectInfo.startDate} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Rating:</h5>
                                            <div className="rating">
                                                {Array(projectInfo.rating)
                                                    .fill(0)
                                                    .map((_, index) => (
                                                        <span className="icon-star" key={index}></span>
                                                    ))}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="project-details__social">
                                        {socialLinks.map((link, index) => (
                                            <Link to={link.href} key={index}>
                                                <span className={link.iconClass}></span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="project-details__need-help">
                                {/* <div className="project-details__need-help-img">
                                    <img
                                        src="/assets/images/project/project-details-need-help-img.jpg"
                                        alt="Need Help"
                                    />
                                </div> */}
                                <div className="project-details__need-help-icon">
                                    <span className="icon-call"></span>
                                </div>
                                <p className="project-details__need-help-sub-title">
                                    Contact Us
                                </p>
                                <h3 className="project-details__need-help-number">
                                    <Link to="tel:+91-9815902561"> +91-9815902561</Link>
                                </h3>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default HydraulicScrapBaler;
